import { useQuery } from '@tanstack/react-query'

import { listMyTenants } from '@/requests/users'

export function useTenantMemberships() {
  return useQuery({
    queryKey: ['tenant-memberships'],
    queryFn: listMyTenants,
  })
}
